import { ParentEnvironment } from '@dice/app/types/env.type';
import { NgxLoggerLevel } from 'ngx-logger';

function getHost(): string {
  if (localStorage.getItem('use-internal-api-gateway') === 'true') {
    return 'dice-api-gateway-dev.dev-scapp-corp.swisscom.com/';
  }
  return 'dice-api-gateway-dev.dev-scapp.swisscom.com/';
  // return 'localhost:9090/';
}

const host = getHost();
const https = 'https://';
const wss = 'wss://';

export const DEV_ENV_CONFIG: ParentEnvironment = {
  name: 'sc-dev',
  publicStates: ['login'],
  apiEndpoint: `${https + host}`,
  wsEndpoint: `${wss + host}`,
  //wsEndpointForUCCP: `ws://localhost:8090/`,
  wsEndpointForUCCP: `${wss + host}`,
  agentViewEndpoint: `agent-view/`,
  anomalyEndpoint: `dice-anomalies/api/anomalies/`,
  auditingEndpoint: `auditing/`,
  budaConfigurationEndpoint: `buda-masterdata/`,
  //budaConfigurationEndpoint: `http://localhost:8789/`,
  budaStatisticsConsumerEndpoint: 'buda-message-proxy/',
  budaStatisticsConsumerEndpointForUCCP: 'buda-message-proxy-uccp/',
  //budaStatisticsConsumerEndpointForUCCP: '',
  agentViewStatisticsConsumerEndpoint: `buda-message-proxy-agentview/`,
  agentInfoStatisticsConsumerEndpoint: `buda-message-proxy-agentinfo/`,
  configEndpoint: `dice-config/api/config/`,
  //easyArchitectEndpoint: `http://localhost:8055/`,
  easyArchitectEndpoint: 'https://easy-architect.uccp-integration-dev.icp.corproot.net/',
  //callbackAdminEndpoint: `http://localhost:8080/`,
  callbackAdminEndpoint: `https://callback-admin.uccp-integration-dev.icp.corproot.net/`,
  callbackAnalyticsEndpoint: `https://callback-analytics.uccp-integration-dev.icp.corproot.net/`,
  dataExchangeEndpoint: `data-exchange/`,
  wfmDataEndpoint: `https://wfm-sap-etl.uccp-integration-dev.icp.corproot.net/`,
  diceUiRedirectPage: 'https://dice-ui.scapp-corp.swisscom.com/',
  eimaEndpoint: `eima/`,
  eimaDREndpoint: `eima-dr/`,
  notifications: `${wss + host}notification/push-message-endpoint`,
  octEndpoint: `chat-campaign-tool/`,
  businessInsightsEndpoint: 'https://uccp-soi-business-insights.uccp-integration-dev.icp.corproot.net/',
  statisticsConsumerEndpoint: `${wss + host}statistics-consumer/websocket`,
  transfertoolAdminURL: 'https://www.dev2.swisscom.ch/omni-transfertool-admin/login',
  userManagementEndpoint: `user-management/`,
  userManualURL: 'https://wiki.swisscom.com/pages/viewpage.action?pageId=617222684',
  logEndpoint: '',
  serverLogLevel: NgxLoggerLevel.DEBUG,
  agentViewManualURL: 'https://wiki.swisscom.com/x/3yHdL',
  budaStatusURL: 'https://dice-dev.dev-scapp-corp.swisscom.com/status',
  cxGenesysModifierURL: 'buda-cx-genesys-modifier/',
  apiProviderURL: 'buda-cx-api-provider/',
  datatableBackupEndpoint: 'https://uccp-soe-datatable-backup.uccp-integration-dev.icp.corproot.net/',
};
